import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableBody,
  Box,
  Tooltip,
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import './Table.scss';

export const TableCustom = ({
  data = [],
  head = [],
  key = 'key',
  clickOnCell = () => {},
  errorMessage = 'No data found',
  pagination = {},
} = {}) => {
  const {
    isShowFirstButton = true,
    isShowLastButton = true,
    numberOfPages = 0,
    currentPage = 0,
    handleChange = () => {},
  } = pagination;

  const tbodyData = data.map((value) => {
    return head.map((thead) => {
      const multiValue = [];

      if (thead?.keys?.length && value[thead[key]]?.length) {
        value[thead[key]].map((innerValue) => {
          thead?.keys?.map((multiTHead) => {
            multiValue.push({ ...multiTHead, value: innerValue[multiTHead.key] });
          });
        });
      }

      return {
        ...thead,
        value: value[thead[key]],
        multiValue: multiValue,
      };
    });
  });

  return (
    <TableContainer component={Paper} style={{ width: '100%' }}>
      <Table className="table">
        <TableHead>
          <TableRow>
            {head?.map((thead, index) => (
              <TableCell hidden={thead?.hide} key={`thead_${index}`} className={thead?.headClass}>
                {thead?.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tbodyData &&
            tbodyData?.map((row, trowIndex) => (
              <TableRow
                key={trowIndex}
                onClick={(event) =>
                  clickOnCell({ action: { type: 'view' }, row, trowIndex }, event)
                }
              >
                {row?.map((tdValue, tdIndex) => (
                  <React.Fragment key={tdIndex}>
                    {tdValue?.type === 'text' && (
                      <TableCell hidden={tdValue?.hide}>
                        <span className={tdValue?.bodyClass}> {tdValue?.value} </span>
                      </TableCell>
                    )}

                    {/* If type array - For array data */}
                    {tdValue?.type === 'array' && (
                      <TableCell hidden={tdValue?.hide}>
                        <span className={tdValue?.bodyClass}>
                          {tdValue?.multiValue?.map((multiVal, multiIndex) => (
                            <span
                              className={multiVal?.arrayClass}
                              hidden={multiVal?.hide}
                              key={multiIndex}
                            >
                              {multiVal?.value}
                            </span>
                          ))}
                        </span>
                      </TableCell>
                    )}
                    {/* End array check */}

                    {tdValue?.type === 'actions' && (
                      <TableCell className={tdValue?.bodyClass} hidden={tdValue?.hide}>
                        <Box>
                          {tdValue?.actions?.map((action, actionIndex) => (
                            <span
                              key={actionIndex}
                              className={action.actionClass}
                              key={actionIndex}
                              onClick={(event) =>
                                clickOnCell(
                                  { action, row, actionIndex, tdIndex, trowIndex, tdValue },
                                  event,
                                )
                              }
                            >
                              <Tooltip key={actionIndex} title={action.text} arrow>
                                <action.icon className={action.bodyClass} />
                              </Tooltip>
                            </span>
                          ))}
                        </Box>
                      </TableCell>
                    )}
                  </React.Fragment>
                ))}
              </TableRow>
            ))}
          {tbodyData?.length === 0 && (
            <TableRow>
              <TableCell colSpan={head?.length} align="center">
                {tbodyData?.length === 0 && errorMessage}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <div className="table-pagination">
        <Pagination
          count={numberOfPages}
          showFirstButton={isShowFirstButton}
          showLastButton={isShowLastButton}
          page={currentPage}
          onChange={handleChange}
        />
      </div>
    </TableContainer>
  );
};
